import { FC, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../../core/Icon/Icon";
import { Typography } from "../../core/Typography/Typography";
import { TypographyVariant } from "../../../constants/typography";
import { useStyles } from "./PwaInstallToast.style";

interface IPwaInstallToastProps {
  open: boolean;
  onClose: () => void;
}

const DISPLAY_DURATION_MS = 3000;

export const PwaInstallToast: FC<IPwaInstallToastProps> = ({
  open,
  onClose,
}) => {
  const classes = useStyles();
  const { t } = useTranslation();

  useEffect(() => {
    if (!open) return;
    const timer = setTimeout(onClose, DISPLAY_DURATION_MS);
    return () => clearTimeout(timer);
  }, [onClose, open]);

  if (!open) return null;

  return (
    <div className={classes.root} role="status">
      <Icon name="icon-bold-tick-circle" size={20} className={classes.icon} />
      <Typography variant={TypographyVariant.BodyB6Medium}>
        {t("Download_App is installed")}
      </Typography>
    </div>
  );
};
